import {defineStore} from 'pinia'
import {deleteCodeByIdentifier} from "@/scripts/api/codes";
import {useToast} from "vue-toastification";
import {QrFormType} from "@/scripts/types/qr";
import {validationRules} from "@/scripts/store/code_types.js";

const toast = useToast();

export const qrCodeFormStore = defineStore('qrCodeFormStore', {
    state: () => ({
        code: null,
    }),
    getters: {
        style(state) {
            return state.code ? state.code.style : {}
        },

        destinationsCount(state) {
            return state.code ? state.code.destinations.length : 0
        },
    },
    actions: {
        validate() {
            const errors = {}

            const destinationsErrors = []
            this.code.destinations.forEach((destination, id) => {
                let destinationErrors = {}

                const rules = validationRules[destination.type];
                if (!rules) {
                    return;
                }

                Object.entries(rules).forEach(([fieldName, validator]) => {
                    const result = validator(destination.data[fieldName]);
                    if (result !== true) {
                        destinationErrors[fieldName] = result
                    }
                });

                if (Object.keys(destinationErrors).length > 0) {
                    destinationsErrors[id] = destinationErrors;
                }
            })

            if (Object.keys(destinationsErrors).length > 0) {
                errors['destinations'] = destinationsErrors
            }

            return errors
        },

        async fetchQrCode(identifier) {
            const response = await axios.get(`/api/qrcode/${identifier}/`);

            this.code = response.data
        },

        initEmptyCode(type, fields) {
            this.code = {
                destinations: [
                    {
                        type: type,
                        data: fields,
                        rules: [],
                        pixel: ''
                    }
                ],
            }

            this.initEmptyStyle()
        },

        initEmptyStyle() {
            this.code = {
                ...this.code,
                style: {
                    formType: QrFormType.SQUARE,
                    size: 32,
                    precision: 'H',
                    pattern: 'default',
                    markerBorder: 'default',
                    markerCenter: 'default',
                    backgroundStyle: {
                        color: '#ffffff00',
                        type: 'color'
                    },
                    foregroundStyle: {
                        type: 'color',
                        color: '#000000'
                    },
                    markersStyle: {
                        isBasic: true,
                        basicBorderColor: '#000000',
                        basicCenterColor: '#000000',
                    },
                    logo: {},
                    frame: {}
                }
            }
        },

        updateBackgroundStyle(style) {
            this.code.style.backgroundStyle = style
        },

        updateForegroundStyle(style) {
            this.code.style.foregroundStyle = {...this.code.style.foregroundStyle, ...style}
        },

        updateMarkersStyle(style) {
            this.code.style.markersStyle = {...this.code.style.markersStyle, ...style}
        },

        updateLogoStyle(style) {
            this.code.style.logo = {...this.code.style.logo, ...style}
        },

        deleteLogoStyle() {
            this.code.style.logo = {}
        },

        updateFrameStyle(style) {
            this.code.style.frame = {...this.code.style.frame, ...style}
        },

        updateStyle(style) {
            this.code.style = {...this.code.style, ...style}
        },

        updateDestination(destinationId, type, data) {
            this.code.destinations[destinationId].type = type
            this.code.destinations[destinationId].data = data
        },

        updateDestinationType(destinationId, type) {
            this.code.destinations[destinationId].type = type
        },

        updateDestinationData(destinationId, data) {
            this.code.destinations[destinationId].data = data
        },

        updateDestinationRule(destinationId, ruleId, rule) {
            this.code.destinations[destinationId].rules[ruleId] = rule
        },

        addDestinationRule(destinationId, rule) {
            this.code.destinations[destinationId].rules.push(rule)
        },

        deleteDestinationRule(destinationId, ruleId) {
            this.code.destinations[destinationId].rules.splice(ruleId, 1)
        },

        addDestination(destination) {
            this.code.destinations.push(destination)
        },

        deleteDestination(destinationId) {
            this.code.destinations.splice(destinationId, 1)
        },

        updateCode(code) {
            this.code = {...this.code, ...code}
        },

        async deleteByIdentifier(identifier) {
            return deleteCodeByIdentifier(identifier)
        },

        async saveCode() {
            try {
                if (this.code.identifier) {
                    const response = await axios.post(`/api/qrcode/${this.code.identifier}`, this.code)
                    this.code = response.data
                } else {
                    const response = await axios.post(`/api/qrcode`, this.code)
                    this.code = response.data
                }
                toast.success("QR код сохранен")
                return true
            } catch (error) {
                if (error.response?.data.code !== 'circle_feature_not_allowed') {
                    toast.error(error.response?.data.message);
                }

                throw error;
            }
        }
    },
})